export class CertificacionPj {

    constructor(config = {}) {
        this.model = {
            id: {
                value: null,
                header: 'Código',
            },
            fecha: {
                value: null,
                header: 'Fecha',
            },
            razon_social: {
                value: '',
                header: 'Razón Social de la entidad:',
                maxLength: 'Máximo 300 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 300,
                min: 4,
                required: 'Campo requerido'
            },
            ruc: {
                value: '',
                header: 'Número de identificación:',
                maxLength: 'Máximo 50 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 50,
                min: 4,
                required: 'Campo requerido'
            },
            pais_constitucion: {
                value: null,
                header: 'País de constitución:',
                required: 'Seleccione alguna opción'
            },
            domicilio_legal: {
                value: '',
                header: 'Domicilio legal: (calle, transversal, número edificio, piso):',
                maxLength: 'Máximo 300 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 300,
                min: 4,
                required: 'Campo requerido'
            },
            pais_legal: {
                value: null,
                header: 'País:',
                required: 'Seleccione alguna opción'
            },
            provincia_legal: {
                value: null,
                header: 'Provincia:',
                required: 'Seleccione alguna opción'
            },
            ciudad_legal: {
                value: null,
                header: 'Ciudad:',
                required: 'Seleccione alguna opción'
            },
            canton_legal: {
                value: '',
                header: 'Ciudad:',
                maxLength: 'Máximo 200 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 200,
                min: 4,
                required: 'Campo requerido'
            },
            codigo_postal_legal: {
                value: '',
                header: 'Código postal:',
                maxLength: 'Máximo 20 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 20,
                min: 4,
                required: 'Campo requerido'
            },
            domicilio_postal: {
                value: '',
                header: 'Dirección Postal : (calle, transversal, número edificio, piso):',
                maxLength: 'Máximo 300 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 300,
                min: 4,
                required: 'Campo requerido'
            },
            pais_postal: {
                value: null,
                header: 'País:',
                required: 'Seleccione alguna opción'
            },
            provincia_postal: {
                value: null,
                header: 'Provincia:',
                required: 'Seleccione alguna opción'
            },
            ciudad_postal: {
                value: null,
                header: 'Ciudad:',
                required: 'Seleccione alguna opción'
            },
            canton_postal: {
                value: '',
                header: 'Ciudad:',
                maxLength: 'Máximo 200 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 200,
                min: 4,
                required: 'Campo requerido'
            },
            codigo_postal: {
                value: '',
                header: 'Código postal:',
                maxLength: 'Máximo 20 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 20,
                min: 4,
                required: 'Campo requerido'
            },
            institucion_inversion: { //Boolean SI o NO
                value: null,
                header: '¿Es una institución financiera o entidad de inversión?',
                required: 'Seleccione alguna opción'
            },
            entidad_custodia: { //Boolean SI o NO
                value: null,
                header: '¿Es una entidad de depósito, custodia, o compañía de seguros?',
                required: 'Seleccione alguna opción'
            },
            entidad_cotiza_bolsa: { //Boolean SI o NO
                value: null,
                header: '¿Es una entidad cuyas acciones se cotizan en bolsa?',
                required: 'Seleccione alguna opción'
            },
            nombre_mercado: {
                value: '',
                header: 'Nombre del mercado en donde se cotiza:',
                maxLength: 'Máximo 200 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 200,
                min: 4,
                required: 'Campo requerido'
            },
            entidad_org: { //Boolean SI o NO
                value: null,
                header: '¿Es una entidad gubernamental u organismo internacional?',
                required: 'Seleccione alguna opción'
            },
            entidad_pasiva: { //Boolean SI o NO
                value: null,
                header: '¿Es una entidad No financiera pasiva?',
                required: 'Seleccione alguna opción'
            },
            eeuu_fin_fiscal: { //Boolean SI o NO
                value: null,
                header: '¿Es ciudadano o residente de los Estados Unidos para fines fiscales?',
                required: 'Seleccione alguna opción'
            },
            eeuu_identificacion: {
                value: '',
                header: 'Número de identificación fiscal de los Estados Unidos (TIN):',
                maxLength: 'Máximo 50 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 50,
                min: 4,
                required: 'Campo requerido'
            },
            extranjero_fin_fiscal: { //Boolean SI o NO
                value: null,
                header: '¿Es ciudadano o residente de otro país para fines fiscales?',
                required: 'Seleccione alguna opción'
            },
        }
    }
    strAuto = <><p>Conforme a las regulaciones del Estándar Común de Reporte (CRS por sus siglas en inglés) en el marco de la OCDE (Organización para la Cooperación
        y Desarrollo Económico), lo establecido en la Disposición General Primera de la Ley Orgánica para la Reactivación de la Economía, Fortalecimiento de la Dolarización
        y Modernización de la Gestión, publicada en el Suplemento del Registro Oficial No. 150 de 29 de diciembre de 2017 y según lo señalado en la Resolución
        NAC-DGERCGC19-00000003 del Servicio de Rentas Internas, publicada en el Suplemento del Registro Oficial No. 428 de 14 de febrero de 2019, se ha dispuesto la
        obligación de reportar información específica sobre la residencia fiscal de una cuenta.</p>
        <p>Con el objeto de dar cumplimiento con la normativa expuesta, se ha implementado el presente formulario de auto-certificación a fin de que los datos registrados en
            el mismo, sean transmitidos al Servicio de Rentas Internas que a su vez podrá enviar esta información a las autoridades fiscales de otras jurisdicciones en
            virtud de acuerdos intergubernamentales para intercambiar información de cuentas financieras.</p>
        <b>Por favor lea estas instrucciones antes de llenar el formulario.-<br /><br />¿Quién debe llenar este formulario?</b>
        <p>El representante que posea uno o más Fideicomisos a nombre de una sociedad.</p>
        <p>No llene este formulario si usted es una persona natural, en su lugar, debe presente un Formulario de Auto- certificación de Residencia Fiscal para PERSONAS NATURALES.</p>
        <p>Si el titular de la cuenta es una entidad no financiera pasiva (en inglés, NFE) o una entidad de inversión ubicada en una jurisdicción no participante y administrada
            por otra institución financiera, utilice el Formulario de Auto- certificación de CRS para persona controlante.</p>
        <p>Tenga en cuenta que este formulario de auto-certificación es solo a efectos de la CRS. El hecho de completarlo no sustituye realizar cualquier Formulario W-9, W-8 o
            de auto-certificación de IRS que pueda requerirse de otra manera para la ley FATCA u otros propósitos fiscales estadounidenses.</p>
        <p>Puede encontrar más información, incluida una lista de jurisdicciones que han firmado acuerdo para intercambiar información automáticamente, junto con los detalles de la
            información solicitada en el portal de la OECD en la sección “Automatic Exchange of Information”:
            <a target="blank" href="http://www.oecd.org/tax/automatic-exchange/">http://www.oecd.org/tax/automatic-exchange/</a>.</p>
    </>
    strCertificacion = <><p>Por este medio certifico que la información proporcionada en este formulario es correcta y completa.</p>
        <p>Autorizo a Trust Fiduciaria Administradora de Fondos y Fideicomisos S.A. a proporcionar, directa o indirectamente, la información contenida en este formulario y/o una 
            copia de este formulario a cualquier autoridad fiscal pertinente o cualquier parte autorizada para auditar o realizar un control similar de Trust Fiduciaria Administradora 
            de Fondos y Fideicomisos S.A para fines fiscales, así como a divulgar a tales autoridades fiscales o tal parte cualquier información adicional que pudiese poseer Trust 
            Fiduciaria Administradora de Fondos y Fideicomisos S.A. y que es pertinente para mi calificación para cualquier beneficio reclamado con base en esta certificación.</p>
        <p>Acepto que la información contenida en este formulario y la información relacionada con mis fideicomisos en Trust Fiduciaria Administradora de Fondos y Fideicomisos S.A. 
            (incluso la información sobre los saldos de cuentas y pagos recibidos) se notifique a las autoridades fiscales pertinentes, y que estas autoridades proporcionen esta 
            información a cualquier otro país enumerado en la lista anterior como a un país en el cual soy residente para fines fiscales.</p></>
}
